import { ThisConnector } from '../../../../../api/connector'
import { BugtrackerRequest } from '../../../bugtrackers/api/shared'
import { buildApiPayloadBugtrackerCredentials } from '../../../bugtrackers/api/build-api-payload-bugtracker-credentials'

export interface GetJiraLabelsArgs {
  organizationUuid?: string
  bugtrackerRequest: BugtrackerRequest | null
  search: string
}

export interface GetJiraLabelsResponse {
  data: Array<{ value: string }>
}

export async function getJiraLabels(
  this: ThisConnector,
  { organizationUuid, bugtrackerRequest, search }: GetJiraLabelsArgs
) {
  const transformedBugtrackerCredentials =
    buildApiPayloadBugtrackerCredentials(bugtrackerRequest)

  const requestBody = {
    query: search,
    ...(transformedBugtrackerCredentials
      ? transformedBugtrackerCredentials
      : {})
  }

  // Intentionally a post request. Not a mistake
  const { data: labels } = await this.connector.post<GetJiraLabelsResponse>(
    `/${organizationUuid}/bugtrackers/jira/labels?expand=skip_links`,
    requestBody
  )

  return labels ? labels.map((label) => label.value) : []
}
